/** 右侧轨迹明细 → 速度曲线数据点 */
export function buildSpeedChartPoints(processedTrackData) {
  if (!Array.isArray(processedTrackData)) return []
  return processedTrackData
    .map((item, index) => item && ({
      time: item.time || '',
      timeMs: item.timeMs,
      trackIndex: item.pointIndex != null ? item.pointIndex : index,
      speed:
        item.spdNum != null && Number.isFinite(Number(item.spdNum))
          ? Number(item.spdNum)
          : 0
    }))
    .filter((item) => item && (item.time || item.timeMs != null))
}

export function resolveSpeedChartTrackRow(processedTrackData, point) {
  if (!Array.isArray(processedTrackData) || !point) return null
  let idx =
    point.trackIndex != null && Number.isFinite(Number(point.trackIndex))
      ? Number(point.trackIndex)
      : -1
  if (idx < 0 && point.time) {
    idx = processedTrackData.findIndex((row) => row && row.time === point.time)
  }
  if (idx < 0 || idx >= processedTrackData.length) return null
  return { index: idx, row: processedTrackData[idx] }
}

/**
 * 速度曲线点击：若在播放则暂停；地图定位并展示 info，不改动播放进度
 * @param {Vue} vm RightData* 组件实例
 * @param {{ index?: number, point?: object }} payload
 */
export function handleSpeedCurvePointClick(vm, payload) {
  if (!vm) return
  const point = payload && payload.point != null ? payload.point : payload
  const trackData = vm.processedTrackData
  if (!Array.isArray(trackData) || !trackData.length) return
  const resolved = resolveSpeedChartTrackRow(trackData, point)
  if (!resolved) return
  const { index, row } = resolved

  if (vm.isPlaying && typeof vm.pauseTrack === 'function') {
    vm.pauseTrack()
  }

  if (typeof vm.goToMap === 'function') {
    vm.goToMap({ ...row, pointIndex: index })
  }
}
